import { render, staticRenderFns } from "./eventPosterV2.vue?vue&type=template&id=aed047a4&scoped=true&"
import script from "./poster.js?vue&type=script&lang=js&"
export * from "./poster.js?vue&type=script&lang=js&"
import style0 from "./eventPosterV2.vue?vue&type=style&index=0&id=aed047a4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aed047a4",
  null
  
)

export default component.exports